import { useState, useEffect } from "react";
import { useToast, Card } from "@chakra-ui/react";
import ListContainer from "components/Wrappers/ListContainer";
import { getNDRs, getNDRExport } from "api/ndr";
import { ExportAction } from "../../components/actions/global/export";
import { Loader } from "components/Loader/loader";
import CreateNDRAction from "components/actions/ndr/create-ndr";
import UpdateNDRAction from "components/actions/ndr/update-ndr";
import DeleteNDRAction from "components/actions/ndr/delete-ndr";
import { columns } from "../../variables/ndrData";
import { getCouriers } from "api/couriers";
import { getMerchants } from "api/merchants";
import { getStatus, getSubStatus } from "api/orders";

function NDR() {
  const [isLoading, setIsLoading] = useState(false);
  const [totalCount, setTotalCount] = useState();
  const [filterQuery, setFilterQuery] = useState({
    page: 1,
    limit: 25,
    filters: {},
    sortAttribute: "",
    sortDirection: "",
  });

  const [openLoader, setOpenLoader] = useState(false);

  const toast = useToast();

  const [ndrData, setNdrData] = useState([]);

  const onExport = async () => {
    setOpenLoader(true);
    try {
        const exportQuery = {
          filters: {
            ...(filterQuery?.filters?.order && { order: filterQuery.filters.order }),
            ...(filterQuery?.filters?.order_number && { order_number: filterQuery.filters.order_number }),
            ...(filterQuery?.filters?.tracking_number && { tracking_number: filterQuery.filters.tracking_number }),
            ...(filterQuery?.filters?.merchant_name && { merchant: filterQuery.filters.merchant_name[0]?.value }),
            ...(filterQuery?.filters?.courier_name && { courier: filterQuery.filters.courier_name[0]?.value }),
            ...(filterQuery?.filters?.consignee_name && { consignee_name: filterQuery.filters.consignee_name }),
            ...(filterQuery?.filters?.consignee_phone && { consignee_phone: filterQuery.filters.consignee_phone }),
            ...(filterQuery?.filters?.consignee_backup_phone && { consignee_backup_phone: filterQuery.filters.consignee_backup_phone }),
            ...(filterQuery?.filters?.city && { city: filterQuery.filters.city }),
            ...(filterQuery?.filters?.status && { 
              status: Array.isArray(filterQuery.filters.status) 
                ? filterQuery.filters.status.map(item => item.value).join(",") 
                : filterQuery.filters.status 
            }),
            ...(filterQuery?.filters?.action && { 
              action: Array.isArray(filterQuery.filters.action) 
                ? filterQuery.filters.action.map(item => item.value).join(",") 
                : filterQuery.filters.action 
            }),
            ...(filterQuery?.filters?.action_taken_by && { 
              action_taken_by: Array.isArray(filterQuery.filters.action_taken_by) 
                ? filterQuery.filters.action_taken_by.map(item => item.value).join(",") 
                : filterQuery.filters.action_taken_by 
            }),
            ...(filterQuery?.filters?.order_status && { 
              order_status: Array.isArray(filterQuery.filters.order_status) 
                ? filterQuery.filters.order_status.map(item => item.value).join(",") 
                : filterQuery.filters.order_status 
            }),
            ...(filterQuery?.filters?.order_sub_status && { 
              order_sub_status: Array.isArray(filterQuery.filters.order_sub_status) 
                ? filterQuery.filters.order_sub_status.map(item => item.value).join(",") 
                : filterQuery.filters.order_sub_status 
            }),
            ...(filterQuery?.filters?.courier_notification_status && { 
              courier_notification_status: Array.isArray(filterQuery.filters.courier_notification_status) 
                ? filterQuery.filters.courier_notification_status.map(item => item.value).join(",") 
                : filterQuery.filters.courier_notification_status 
            }),
            ...(filterQuery?.filters?.redelivery_date && {
              redelivery_date_from: filterQuery.filters.redelivery_date.from || filterQuery.filters.redelivery_date[0],
              redelivery_date_to: filterQuery.filters.redelivery_date.to || filterQuery.filters.redelivery_date[1],
            }),
            ...(filterQuery?.filters?.action_requested_date && {
              action_requested_date_from: filterQuery.filters.action_requested_date.from || filterQuery.filters.action_requested_date[0],
              action_requested_date_to: filterQuery.filters.action_requested_date.to || filterQuery.filters.action_requested_date[1],
            }),
            ...(filterQuery?.filters?.created_at && {
              created_at_from: filterQuery.filters.created_at.from || filterQuery.filters.created_at[0],
              created_at_to: filterQuery.filters.created_at.to || filterQuery.filters.created_at[1],
            }),
            ...(filterQuery?.filters?.updated_at && {
              updated_at_from: filterQuery.filters.updated_at.from || filterQuery.filters.updated_at[0],
              updated_at_to: filterQuery.filters.updated_at.to || filterQuery.filters.updated_at[1],
            }),
          }
        };

      Object.keys(exportQuery.filters).forEach(key => {
        if (!exportQuery.filters[key]) {
          delete exportQuery.filters[key];
        }
      });

      const res = await getNDRExport(exportQuery, toast);
      if (res) {
        openFileInNewTab(res);
      }
    } catch (error) {
      console.error("Export error:", error);
      toast({
        title: "Export failed",
        description: "Unable to export NDR data",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    }
    setOpenLoader(false);
  };

  const openFileInNewTab = (response) => {
    const file = new Blob([response.data], { type: "text/csv" });
    const fileURL = URL.createObjectURL(file);
    const a = document.createElement('a');
    a.href = fileURL;
    a.download = 'ndrs.csv';
    a.click();
    URL.revokeObjectURL(fileURL);
  };

  const fetchData = async (query) => {
    setIsLoading(true);
    try {
      console.log("Query:", query);
      console.log("Date filters:", {
        created_at: query?.filters?.created_at,
        updated_at: query?.filters?.updated_at,
        redelivery_date: query?.filters?.redelivery_date,
        action_requested_date: query?.filters?.action_requested_date
      });
      const filters =  {
        ...(query?.filters?.order && { order: query.filters.order }),
        ...(query?.filters?.order_number && { order_number: query.filters.order_number }),
        ...(query?.filters?.tracking_number && { tracking_number: query.filters.tracking_number }),
        ...(query?.filters?.merchant_name && { merchant: query.filters.merchant_name[0]?.value }),
        ...(query?.filters?.courier_name && { courier: query.filters.courier_name[0]?.value }),
        ...(query?.filters?.consignee_name && { consignee_name: query.filters.consignee_name }),
        ...(query?.filters?.consignee_phone && { consignee_phone: query.filters.consignee_phone }),
        ...(query?.filters?.consignee_backup_phone && { consignee_backup_phone: query.filters.consignee_backup_phone }),
        
          ...(query?.filters?.city && { city: query.filters.city }),
        
        ...(query?.filters?.status && { 
          status: Array.isArray(query.filters.status) 
            ? query.filters.status.map(item => item.value).join(",") 
            : query.filters.status 
        }),
        ...(query?.filters?.action && { 
          action: Array.isArray(query.filters.action) 
            ? query.filters.action.map(item => item.value).join(",") 
            : query.filters.action 
        }),
        ...(query?.filters?.action_taken_by && { 
          action_taken_by: Array.isArray(query.filters.action_taken_by) 
            ? query.filters.action_taken_by.map(item => item.value).join(",") 
            : query.filters.action_taken_by 
        }),
        ...(query?.filters?.order_status && { 
          order_status: Array.isArray(query.filters.order_status) 
            ? query.filters.order_status.map(item => item.value).join(",") 
            : query.filters.order_status 
        }),
        ...(query?.filters?.order_sub_status && { 
          order_sub_status: Array.isArray(query.filters.order_sub_status) 
            ? query.filters.order_sub_status.map(item => item.value).join(",") 
            : query.filters.order_sub_status 
        }),
        ...(query?.filters?.courier_notification_status && { 
          courier_notification_status: Array.isArray(query.filters.courier_notification_status) 
            ? query.filters.courier_notification_status.map(item => item.value).join(",") 
            : query.filters.courier_notification_status 
        }),
        
        ...(query?.filters?.redelivery_date && {
          redelivery_date_from: query.filters.redelivery_date.from || query.filters.redelivery_date[0],
          redelivery_date_to: query.filters.redelivery_date.to || query.filters.redelivery_date[1],
        }),
        ...(query?.filters?.action_requested_date && {
          action_requested_date_from: query.filters.action_requested_date.from || query.filters.action_requested_date[0],
          action_requested_date_to: query.filters.action_requested_date.to || query.filters.action_requested_date[1],
        }),
        ...(query?.filters?.created_at && {
          created_at_from: query.filters.created_at.from || query.filters.created_at[0],
          created_at_to: query.filters.created_at.to || query.filters.created_at[1],
        }),
        ...(query?.filters?.updated_at && {
          updated_at_from: query.filters.updated_at.from || query.filters.updated_at[0],
          updated_at_to: query.filters.updated_at.to || query.filters.updated_at[1],
        }),
      }
      console.log(query?.filters?.created_at);

      const res = await getNDRs({
        page: query.page, 
        limit: query.limit,
        sortAttribute: query.sortAttribute?.length > 0 ? query.sortAttribute[0]?.value : "created_at",
        sortDirection: query.sortDirection?.length > 0 ? query.sortDirection[0]?.value : "desc",
        filters
      }, toast);

      if (res && res.items) {
        const flattenedData = res.items.map(item => ({
          ...item,
          order_number: item.order?.orderNumber || "-",
          tracking_number: item.order?.externalId || "-",
          merchant_name: item?.order?.merchant?.business_info?.brand || "-",
          courier_name: item.courier || "-",
          name: item.name || `NDR Attempt #${item._id.slice(-4)}`,
          consignee_name: item.order?.customer_details?.personal_info?.name || "-",
          consignee_phone: item.order?.customer_details?.personal_info?.phone || "-",
          consignee_backup_phone: item.order?.customer_details?.personal_info?.backup_phone || "-",
          city: item.order?.customer_details?.address_info?.city || "-",
          status: item.status || "-",
          action: item.action || "-",
          action_taken_by: item.action_taken_by || "-",
          order_status: item.order?.status || "-",
          order_sub_status: item.order?.sub_status || "-",
          courier_notification_status: item.is_courier_notified ? "notified" : "not_notified",
          validation_result: item.validation_result || "-",
          non_delivery_reason: item.non_delivery_reason || "-",
          customer_phone: item.customer_phone || "-",
          created_at: item.created_at || "-",
          updated_at: item.updated_at || "-",
        }));

        console.log("Flattened NDR data:", flattenedData[0]);
        setNdrData(flattenedData);
        setTotalCount(res.totalCount || res.items.length);
      } else {
        console.log("No data in response");
        setNdrData([]);
        setTotalCount(0);
      }
    } catch (error) {
      console.error("Error fetching NDRs:", error);
      setNdrData([]);
      setTotalCount(0);
    }
    setIsLoading(false);
  };

  const globalActions = [
    // {
    //   name: "create",
    //   component: () => <CreateNDRAction onUpdate={() => fetchData(filterQuery)} />,
    //   validation: () => true,
    // },
    {
      name: "export",
      component: () => <ExportAction onclickExport={onExport} />,
      validation: () => true,
    },
  ];

  const getDropDowns = async () => {
    const statusCol = columns.find(
      (col) => col.type === "multi_select" && col.name === "status"
    );
    if (statusCol) {
      statusCol.options = [
        { value: "raised", label: "Raised" },
        { value: "in_progress", label: "In Progress" },
        { value: "cancelled", label: "Cancelled" },
        { value: "resolved", label: "Resolved" },
        { value: "failed", label: "Failed" },
      ];
    }

    const actionCol = columns.find(
      (col) => col.type === "multi_select" && col.name === "action"
    );
    if (actionCol) {
      actionCol.options = [
        { value: "pending", label: "Pending" },
        { value: "re-deliver", label: "Re-deliver" },
        { value: "return", label: "Return" },
      ];
    }

    const actionTakenByCol = columns.find(
      (col) => col.type === "multi_select" && col.name === "action_taken_by"
    );
    if (actionTakenByCol) {
      actionTakenByCol.options = [
        { value: "courier", label: "Courier" },
        { value: "system", label: "System" },
        { value: "merchant", label: "Merchant" },
        { value: "consignee", label: "Consignee" },
        { value: "admin", label: "Admin" },
      ];
    }

    const orderStatusCol = columns.find(
      (col) => col.type === "multi_select" && col.name === "order_status"
    );
    try {
      const statusRes = await getStatus(toast);
      if (statusRes && statusRes.statuses && orderStatusCol) {
        orderStatusCol.options = statusRes.statuses.map(status => ({
          value: status.value || status.name,
          label: status.label || status.name
        }));
      }
    } catch (error) {
      console.error("Error fetching order statuses:", error);
      if (orderStatusCol) {
        orderStatusCol.options = [
          { value: "pending", label: "Pending" },
          { value: "processing", label: "Processing" },
          { value: "successful", label: "Successful" },
          { value: "unsuccessful", label: "Unsuccessful" },
          { value: "cancelled", label: "Cancelled" },
        ];
      }
    }

    const orderSubStatusCol = columns.find(
      (col) => col.type === "multi_select" && col.name === "order_sub_status"
    );
    try {
      const subStatusRes = await getSubStatus(toast);
      if (subStatusRes && subStatusRes.subStatuses && orderSubStatusCol) {
        orderSubStatusCol.options = subStatusRes.subStatuses.map(subStatus => ({
          value: subStatus.value || subStatus.name,
          label: subStatus.label || subStatus.name
        }));
      }
    } catch (error) {
      console.error("Error fetching order sub-statuses:", error);
      if (orderSubStatusCol) {
        orderSubStatusCol.options = [
          { value: "Picked Up".toLowerCase(), label: "Picked Up" },
          { value: "Delivered to Customer".toLowerCase(), label: "Delivered to Customer" },
          { value: "deliveryFailedReturnedToMerchant", label: "Delivery Failed & Returned to Merchant" },
          { value: "Problematic".toLowerCase(), label: "Problematic" },
          { value: "At Courier Hub".toLowerCase(), label: "At Courier Hub" },
          { value: "Failed Attempt".toLowerCase(), label: "Failed Attempt" },
          { value: "Out for Delivery".toLowerCase(), label: "Out for Delivery" },
          { value: "New".toLowerCase(), label: "New" },
          { value: "Cancelled".toLowerCase(), label: "Cancelled" },
          { value: "Missing Area".toLowerCase(), label: "Missing Area" },
          { value: "Missing Tracking".toLowerCase(), label: "Missing Tracking" },
          { value: "Duplicate".toLowerCase(), label: "Duplicate" },
          { value: "Ready".toLowerCase(), label: "Ready" },
          { value: "Out for Exchange".toLowerCase(), label: "Out for Exchange" },
          { value: "Exchanged & Returned to Courier".toLowerCase(), label: "Exchanged & Returned to Courier" },
          { value: "Exchanged & Returned to Merchant".toLowerCase(), label: "Exchanged & Returned to Merchant" },
          { value: "Exchange Failed & Returned to Merchant".toLowerCase(), label: "Exchange Failed & Returned to Merchant" },
          { value: "Out for Return".toLowerCase(), label: "Out for Return" },
          { value: "Returned to Courier".toLowerCase(), label: "Returned to Courier" },
          { value: "Returned to Merchant".toLowerCase(), label: "Returned to Merchant" },
          { value: "Return Failed".toLowerCase(), label: "Return Failed" },
        ];
      }
    }

    const courierNotificationCol = columns.find(
      (col) => col.type === "multi_select" && col.name === "courier_notification_status"
    );
    if (courierNotificationCol) {
      courierNotificationCol.options = [
        { value: "not_notified", label: "Not Notified" },
        { value: "notified", label: "Notified" },
      ];
    }

    // Courier options
    const courierCol = columns.find(
      (col) => col.type === "multi_select" && col.name === "courier_name"
    );
    try {
      const { couriers } = await getCouriers({ page: 1, limit: 10000 }, toast);
      if (couriers && courierCol) {
        courierCol.options = couriers.map(item => ({ value: item.name, label: item.name }));
      }
    } catch (error) {
      console.error("Error fetching couriers:", error);
    }

    // Merchant options
    const merchantCol = columns.find(
      (col) => col.type === "multi_select" && col.name === "merchant_name"
    );
    try {
      const { merchants } = await getMerchants({ page: 1, limit: 10000 }, toast);
      if (merchants && merchantCol) {
        merchantCol.options = merchants.map(item => ({ value: item.brand, label: item.brand }));
      }
    } catch (error) {
      console.error("Error fetching merchants:", error);
    }
  };

  const tableActions = {
    NDR: [
      // {
      //   name: "update",
      //   component: (row) => (
      //     <UpdateNDRAction row={row} onUpdate={() => fetchData(filterQuery)} />
      //   ),
      //   validation: () => true,
      // },
      // {
      //   name: "delete",
      //   component: (row) => (
      //     <DeleteNDRAction row={row} onUpdate={() => fetchData(filterQuery)} />
      //   ),
      //   validation: () => true,
      // },
    ],
  };

  useEffect(() => {
    fetchData(filterQuery);
    
    // Set up link column click handler
    const ndrNameCol = columns.find((col) => col.type === "link" && col.name === 'name');
    if (ndrNameCol) {
      ndrNameCol.onClickLink = (row) => {
        // You can implement a detailed view or just show the update modal
        console.log("NDR clicked:", row);
      };
    }
    
    getDropDowns();
  }, [filterQuery.page]);

  return (
    <>
      <Loader isLoading={openLoader} />

      <Card
        marginTop={"2rem"}
        padding={6}
        borderRadius={40}
        height={"calc(100vh - 4rem)"}
      >
        <ListContainer
          fullHeight
          title="Non Delivery Reports (NDR)"
          columns={columns}
          data={ndrData}
          filterQuery={filterQuery}
          setFilterQuery={setFilterQuery}
          totalCount={totalCount}
          tableActions={tableActions["NDR"]}
          hasPagination={true}
          fetchData={fetchData}
          isLoading={isLoading}
          globalActions={globalActions}
        />
      </Card>
    </>
  );
}

export default NDR;
